import React, { useState, useEffect } from "react";
import "./MailIcon.css";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import { useAuth } from "../../AuthContext";
import { useBaseUrl } from "../../ApiContext";

export default function MailIcon(props) {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const navigate = useNavigate();
  const [newTicketsCount, setNewTicketsCount] = useState(null);

  useEffect(() => {
    const fetchNewMessageCount = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/tickets/new_message_count`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        const data = response.data;
        if (data) {
          setNewTicketsCount(data.count);
        }
      } catch (error) {
        console.log("Error during getting new message count", error);
      }
    };
    fetchNewMessageCount();
  }, [userToken, baseUrl]);

  const navigateToTickets = () => {
    navigate("/tickets", { state: { from: props.loc } });
  };

  return (
    <div className="messages" onClick={navigateToTickets}>
      <MailOutlineIcon className="mailBoxIcon" />
      {newTicketsCount > 0 && (
        <div className="messagesBadge centeredFlex">
          <span>{newTicketsCount}</span>
        </div>
      )}
    </div>
  );
}
